import { Box, Card, CardContent, Divider, Typography } from "@mui/material";
import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { UserAddress } from "../../../types/userAddress";
import AddressSelector from "../checkout/AddressSelector";

const ProfileAddress: React.FC = () => {
  const { t } = useTranslation();
  const [selectedAddressId, setSelectedAddressId] = useState<string>();
  const [selectedAddress, setSelectedAddress] = useState<UserAddress | null>(
    null
  );

  const handleAddressSelect = useCallback((addressId: string) => {
    setSelectedAddressId(addressId || undefined);
    if (!addressId) {
      setSelectedAddress(null);
    }
  }, []);

  const handleAddressChange = useCallback((address: UserAddress) => {
    setSelectedAddressId(address.id);
    setSelectedAddress(address);
  }, []);

  const formattedSelectedAddress = useMemo(() => {
    if (!selectedAddress) return null;
    return [selectedAddress.addressLine1, selectedAddress.city, selectedAddress.country]
      .filter(Boolean)
      .join(", ");
  }, [selectedAddress]);

  return (
    <Box className="notranslate" translate="no">
      <Typography
        variant="h5"
        sx={{ fontWeight: 600, mb: 3 }}
        className="notranslate"
        translate="no"
      >
        {t("profile.savedAddresses")}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 3 }}
        className="notranslate"
        translate="no"
      >
        {t("profile.manageDeliveryAddresses")}
      </Typography>

      <AddressSelector
        selectedAddressId={selectedAddressId}
        onAddressSelect={handleAddressSelect}
        onAddressChange={handleAddressChange}
        showHeader={false}
      />

      {selectedAddress && formattedSelectedAddress && (
        <Card elevation={1} sx={{ mt: 3 }}>
          <CardContent>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, mb: 1 }}
              className="notranslate"
              translate="no"
            >
              {t("profile.currentlySelectedAddress")}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {formattedSelectedAddress}
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Typography
              variant="body2"
              color="text.secondary"
              className="notranslate"
              translate="no"
            >
              {t("profile.phone")} {selectedAddress.phoneNumber}
            </Typography>
            {selectedAddress.deliveryInstructions && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 1 }}
                className="notranslate"
                translate="no"
              >
                {t("profile.instructions")}{" "}
                {selectedAddress.deliveryInstructions}
              </Typography>
            )}
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default ProfileAddress;
